import { EtlClientInterface } from "etl/core"
import { EtlApiTarget, getTargetFromSchema, HttpVerb } from "etl/types";
import { etlAxiosBaseQuery } from "./etl-axios-instance";
import { getApiUrl } from "backend-routes";

export const etlAxiosClient: EtlClientInterface = {
	/************************************************************\
						ALL ABOUT GENERIC DATA
	\************************************************************/

	async loginWithPasswordAndEmail(username, password) {
		return await etlAxiosBaseQuery({
			url: EtlApiTarget.ETL_AUTH,
			method: HttpVerb.POST,
			data: { username, password },
		});
	},

	async find(schema, id) {
		const target = getTargetFromSchema(schema);
		const group = schema.description;

		if (!target) throw new Error("Target is required");

		return etlAxiosBaseQuery({
			url: `${target}/${id}`,
			method: HttpVerb.GET,
			params: {
				groups: [group],
			},
		});
	},

	async findAll(schema, config = {}, raw) {
		const target = getTargetFromSchema(schema);
		const group = schema.description;

		if (!target) throw new Error("Target is required");

		config.params = { groups: [group], ...config.params };

		const response = await etlAxiosBaseQuery({
			url: target,
			method: HttpVerb.GET,
			...config,
		});

		if (raw === true) return response.data;

		return response.data["hydra:member"] ? response.data["hydra:member"] : response.data;
	},

	async update(schema, id, data, verb = HttpVerb.PATCH) {
		const target = getTargetFromSchema(schema);

		if (!target) throw new Error("Target is required");

		return etlAxiosBaseQuery({
			url: `${target}/${id}`,
			method: verb,
			data,
		});
	},

	async create(schema, data) {
		const target = getTargetFromSchema(schema);

		if (!target) throw new Error("Target is required");

		return (await etlAxiosBaseQuery({
			url: target,
			method: HttpVerb.POST,
			data,
		}));
	},

	async trigger(target, uuid, data) {
		return (await etlAxiosBaseQuery({
			url: `${uuid}/${target}`,
			method: HttpVerb.POST,
			data,
		}));
	},

	/************************************************************\
						ALL ABOUT DOCUMENT
	\************************************************************/

	async uploadFile(uuid, data) {
		if (data.laboratoryId) {
			return await etlAxiosBaseQuery({
				url: `${EtlApiTarget.UPLOAD_FILE_LABORATORY.replace(":uuid", uuid).replace(":labId", data.laboratoryId).replace(":fileName", data.fileName)}`,
				method: HttpVerb.POST,
				data: data.formData,
			});
		} else {
			return await etlAxiosBaseQuery({
				url: `${EtlApiTarget.UPLOAD_FILE_GLOBAL.replace(":uuid", uuid).replace(":fileName", data.fileName)}`,
				method: HttpVerb.POST,
				data: data.formData,
			});
		}
	},

	async downloadCsv(uuid, baseClassName, labId) {
		const params: Record<string, string> = { baseClassName };
		if (labId) params.labId = labId;

		return await etlAxiosBaseQuery({
			url: `${uuid}/${EtlApiTarget.DOWNLOAD_CSV_API}`,
			method: HttpVerb.GET,
			params,
			responseType: "blob",
		});
	},

	async reuploadCsv(uuid, data) {
		const formData = data.formData;
		formData.append("baseClassName", data.baseClassName);
		if (data.labId) formData.append("labId", data.labId);

		return await etlAxiosBaseQuery({
			url: `${uuid}/${EtlApiTarget.REUPLOAD_CSV_API}`,
			method: HttpVerb.POST,
			data: formData,
		});
	},

	getMercureUrl() {
		return getApiUrl().mercureUrl;
	},

}

export default etlAxiosClient
